export default "__VITE_ASSET__7919c08c__"